import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'

/**
 * Окно подбора и печати ценников 1С (UB1d). Адрес содержит `:rid`: подбор
 * одной базы не смешивается с подбором другой. Вкладка ничего не снимает —
 * подбор сам переживает перезагрузку (срок `device`).
 */
export const ONEC_PRICE_TAG_WINDOWS = {
  priceTags: 'onec.price-tags',
} as const

export const priceTagWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_PRICE_TAG_WINDOWS.priceTags,
    scope: 'resource',
    paths: ['/onec/:rid/price-tags'],
    label: 'Ценники 1С',
    size: 'lg',
  },
]
